<template>
  <router-view />
</template>
<script>
  export default {
    name: 'ServicoModule',
  }
</script>
